import { writable } from 'svelte/store'

export const currentUserStore = writable(false)